import { Link } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import { layout } from 'styles/layout';
import {
  Recommendation,
  RecommendationCarouselContainer,
  RecommendationImage,
  RecommendationsSlider,
  RecommendationsSliderContainer,
  RecommendationTitle
} from './RecommendationsCarousel.styles';

interface RecommendationsCarouselProps {
  posts: {
    title: string;
    slug: string;
    image: IGatsbyImageData
  }[];
}

const RecommendationsCarousel = ({ posts }: RecommendationsCarouselProps): JSX.Element => {
  const subMdBreakpoint = parseInt(layout.subMd.replace('px', ''));

  const sliderSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [ {
      breakpoint: subMdBreakpoint,
      settings: {
        slidesToShow: 2,
        dots: true,
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots: true,
      }
    } ]
  };

  return (
    <RecommendationCarouselContainer>
      <RecommendationsSliderContainer>
        <RecommendationsSlider {...sliderSettings}>
          {
            posts.map((post, index) => (
              <Link to={`/resources/${post.slug}`} key={index}>
                <Recommendation>
                  <RecommendationTitle>
                    <Heading
                      text={post.title}
                      size="22px"
                      weight="normal"
                      align="left"
                    />
                  </RecommendationTitle>
                  <RecommendationImage>
                    <Image childImageSharp={ post.image } alt={post.title}/>
                  </RecommendationImage>
                </Recommendation>
              </Link>
            ))
          }
        </RecommendationsSlider>
      </RecommendationsSliderContainer>
    </RecommendationCarouselContainer>
  );
};

export default RecommendationsCarousel;
